import { createContext } from "react";
import PubSub from "PubSub";
var PubsubEventBus = /** @class */ (function () {
    function PubsubEventBus() {
        this.bus = PubSub.createInstance().alias({
            subscribe: "on",
            subscribeOnce: "once",
            publish: "trigger",
            publishSync: "triggerSync",
            unsubscribe: "off",
            hasSubscribers: "has",
        });
        this.on = this.subscribe;
        this.once = this.subscribeOnce;
        this.trigger = this.publish;
        this.off = this.unsubscribe;
    }
    PubsubEventBus.prototype.subscribe = function (topic, callback) {
        return this.bus.subscribe(topic, callback);
    };
    PubsubEventBus.prototype.subscribeOnce = function (topic, callback) {
        return this.bus.subscribeOnce(topic, callback);
    };
    PubsubEventBus.prototype.publish = function (topic, data) {
        return this.bus.publish(topic, data);
    };
    PubsubEventBus.prototype.unsubscribe = function (subscription) {
        return this.bus.unsubscribe(subscription);
    };
    return PubsubEventBus;
}());
export { PubsubEventBus };
export var createEventBus = function () { return new PubsubEventBus(); };
export var EventBusContext = createContext(createEventBus());
